import actionTypes from 'Redux/constants';

const createReviewInitialState = {
  isOpen: false,
  selectedReview: null,
};

export function createReviewReducer(state = createReviewInitialState, action) {
  switch (action.type) {
    case actionTypes.createReview.openCreateReviewModal:
      return {
        ...state,
        isOpen: true,
        selectedReview: action.payload.selectedReview,
      };
    case actionTypes.createReview.closeCreateReviewModal:
      return {
        ...state,
        isOpen: false,
        selectedReview: null,
      };
    case actionTypes.createReview.setSelectedReview:
      return {
        ...state,
        selectedReview: action.payload,
      };
    case actionTypes.createReview.clearSelectedReview:
      return {
        ...state,
        selectedReview: null,
      };
    default:
      return state;
  }
}
